// extracted by mini-css-extract-plugin
export default {"container":"styles_container__hGJ32","link":"styles_link__dN4rK","close":"styles_close__advKe"};